module.exports = __webpack_public_path__ + "img/qr-wx-gzh.26c77c16.png";